module.exports = __webpack_public_path__ + "img/wptjh.028aac49.jpg";